import {IBaseLookup} from "./Ibase.lookup";

export namespace Modality {

    export const lookupName: string = "Modality";

    export interface ModalityAvailableException {
        modalityAvailExceptionKey: number;
        fromDate: Date;
        toDate: Date;
        reason: string;
        availabilityIndicatorKey: number;
        exceptionCreatedPersonKey: number;
        exceptionCreatedDate: Date;
        modalityKey: number;
        lastUpdated: Date;
        priority: number;
    }

    export interface ModalityGroup {
        modalityGroupKey: number;
        name: string;
        description: string;
        active: string;
        lastUpdated: Date;
    }

    export interface ModalityXGroup {
        modalityXGroupKey: number;
        modalityGroupKey: number;
        modalityKey: number;
        lastUpdated: Date;
    }

    export interface ModalityXModality {
        modalityXModalityKey: number;
        sourceModalityKey: number;
        destinationModalityKey: number;
        lastUpdated: Date;
    }

    export interface Modality {
        modalityKey: number;
        code: string;
        description: string;
        aeTitle: string;
        stationName: string;
        modalityTypeKey: number;
        digital: string;
        openDate: Date;
        closeDate: Date;
        location: string;
        allowScheduling: string;
        active: string;
        orgStructureKey: number;
        lastUpdated: Date;
        maxStudiesTimeslot: number;
        waitingRoomKey: number;
        excludeFromSearch: string;
		excludeFromSchedulingMyview: string;
        inventoryRoomKey: number;
        resourceLocationKey: number;
        modalityTypeCode: string;
		schedulingPriority: number;
		timeSlotSize: number;
    }

    export interface ModalityDS extends IBaseLookup {
        modalityAvailableException: ModalityAvailableException[];
        modalityGroup: ModalityGroup[];
        modalityXGroup: ModalityXGroup[];
        modalityXModality: ModalityXModality[];
        modality: Modality[];
    }
}
